/* BUSINESS INFORMATION */
const business = {
  name: 'Malama Land',
  phone: '(928) 277-8196',
  email: 'Hello@MalamaLand.com'
};

export default business;